export const getters = {
  getForm(state) {
    return state.customTranslationForm;
  },
  getFormData(state) {
    return state.customTranslationForm ? state.customTranslationForm.data : null;
  },
};
